import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import './styles/main.css';
import App from './App.jsx';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import reportWebVitals from './reportWebVitals';
import NotificationProvider from './components/NotificationProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // Eliminați temporar React.StrictMode
   <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <NotificationProvider> {/* Încapsulează App în NotificationProvider */}
        <App />
      </NotificationProvider>
    </I18nextProvider>
   </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
